import { CAIP19, Chain, Config, makeRequest } from "@paywithglide/glide-js";

export type ListGlideRoutesArgs = {
  paymentCurrency: CAIP19;
  spendCurrency: CAIP19;
};

export type GlideRoute = {
  id: string;
  priority: "speed" | "cost";
  maxAmount: string;
};

export async function listGlideRoutes<chains extends readonly Chain[]>(
  config: Config<chains>,
  body: ListGlideRoutesArgs,
) {
  return await makeRequest<GlideRoute[]>(config, {
    method: "POST",
    url: "/list-routes",
    body,
  });
}
